import { render, staticRenderFns } from "./NewContentTypeModal.vue?vue&type=template&id=3dccca53"
import script from "./NewContentTypeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewContentTypeModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports